import apiClient from './apiClient';

// ============================================================
// Types — matching backend Go models for PWG501F1 (繳款單核准)
// ============================================================

export interface ApprovalCandidate {
  fg110_01: string; // 繳款單號
  fg110_11: string; // 繳款日期
  fg110_15: string; // 廠商代碼
  fg110_17: string; // 類型碼
  fg110_18: string; // 過帳狀態
  fg110_19: string; // 部門代碼
  fg110_24: string; // 水單匯率
  fg110_28: string; // 繳款類型
  fg110_80: string; // 核准狀態
}

export interface QueryResponse {
  items: ApprovalCandidate[];
  total: number;
}

export interface ApproveResponse {
  success: number;
  failed: number;
  errors?: string[];
  message: string;
}

// ============================================================
// API methods
// ============================================================

export const pwg501Api = {
  /** Query payment slip candidates eligible for approval */
  async queryCandidates(startNo: string, endNo: string): Promise<QueryResponse> {
    const params: Record<string, string> = {};
    if (startNo.trim()) params['start'] = startNo.trim();
    if (endNo.trim()) params['end'] = endNo.trim();
    const res = await apiClient.get('/api/pwg501/candidates', { params });
    return res.data;
  },

  /**
   * Execute batch approval for selected payment slips.
   * PWG501-VAL-APPROVE-CONFIRM-DIALOG (human_approved 2026-07-23): backend
   * now rejects any call missing an explicit confirmed:true with 422 + zero
   * DB mutation. Callers must only invoke this after the user has confirmed
   * (e.g. inside a Modal.confirm's onOk), same as pwh508f1/pwh5m8f1/pwg504f1's
   * own frontend API clients.
   */
  async approve(items: string[], confirmed: boolean = true): Promise<ApproveResponse> {
    const res = await apiClient.post('/api/pwg501/approve', { items, confirmed });
    return res.data;
  },
};
